export default __webpack_public_path__ + "static/media/mike_frassinelli_head.04702ad2.jpg";